<template>
  <div>
    <b-card>
      <b-row class="mb-1 align-items-center">
      <b-col
        cols="12"
        sm="3"
        class="d-flex align-items-center justify-content-center justify-content-sm-start mb-1 mb-sm-0"
      >
        <h4 class="mb-0 card-title">MiME Talk Services</h4>
      </b-col>
      <b-col
        cols="12"
        sm="9"
        class="kothon-bulk-actions d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-button
          variant="info"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center"
          @click="openCdrModal"
        >
          <feather-icon icon="SearchIcon" size="14" class="mr-50" />
          Search CDRs
        </b-button>
        <b-button
          v-if="userDetails && userDetails.interested_on === 'corporate'"
          variant="primary"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center"
          @click="openBulkSelectionModal"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Bulk Recharge Upload
        </b-button>
        <b-button
          v-if="userDetails && userDetails.interested_on === 'corporate'"
          variant="primary"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center"
          @click="openBulkSetLimitSelectionModal"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Bulk Set Limit Upload
        </b-button>
        <b-button
          v-if="userDetails && userDetails.interested_on === 'corporate'"
          variant="warning"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center"
          @click="openBulkRechargeModal"
        >
          <feather-icon icon="ZapIcon" size="14" class="mr-50" />
          Bulk Recharge
        </b-button>
        <b-button
          v-if="userDetails && userDetails.interested_on === 'corporate'"
          variant="success"
          size="sm"
          class="kothon-bulk-action-btn d-inline-flex align-items-center justify-content-center"
          @click="openDownloadSummaryModal"
        >
          <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
          Download Summary Excel
        </b-button>
      </b-col>
    </b-row>
      <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap" style="gap: 0.5rem;">
        <div class="d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
          <span class="text-muted" style="font-size: 13px;">Per Page</span>
          <b-form-select
            v-model="mimetalkLimit"
            :options="mimetalkLimitOptions"
            size="sm"
            class="did-limit-select"
            @change="onMimetalkLimitChange"
          />
          <span class="text-muted" style="font-size: 13px;">
            {{ mimetalkTotalCount }} line(s)
          </span>
        </div>
        
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <b-form-select
            v-model="mimetalkHasLimit"
            :options="mimetalkHasLimitOptions"
            size="sm"
            class="mimetalk-status-select"
            @change="onMimetalkHasLimitChange"
          />
          <b-form-select
            v-model="mimetalkStatusFilter"
            :options="mimetalkStatusFilterOptions"
            size="sm"
            class="mimetalk-status-select"
            @change="onMimetalkStatusFilterChange"
          />
          <b-form-input
            v-model="mimetalkSearchQuery"
            placeholder="Search by mobile, SIP or package..."
            size="sm"
            class="mimetalk-search-input"
            @input="onMimetalkSearchInput"
          />
        </div>
      </div>
      <b-table
        responsive
        :items="sipnumbers"
        :fields="fields"
        sticky-header="500px"
        show-empty
        empty-text="No MiME Talk Service Found"
        ref="mimetalkTable"
      >
        <template #cell(select)="data">
          <b-form-checkbox
            :checked="isSelected(data.item.id)"
            @change="toggleSelection(data.item.id)"
          />
        </template>

        <template #head(select)>
          <b-form-checkbox
            :checked="isAllSelected"
            @change="toggleSelectAll"
          />
        </template>

        <template #cell(sl)="row">
          {{ mimetalkLimit === -1 ? row.index + 1 : (mimetalkOffset) + row.index + 1 }}
        </template>

        <template #cell(balance)="row">
          {{ row.item.balance != null ? row.item.balance : '-' }}
        </template>
        <template #cell(block_status)="row">
          <b-badge
            :variant="row.item.block_status === 'unblocked' ? 'success' : 'danger'"
          >
            {{ row.item.block_status === "unblocked" ? "Active" : "Inactive" }}
          </b-badge>
        </template>
        <template #cell(action)="data">
          <b-dropdown
            variant="primary"
            toggle-class="text-nowrap d-inline-flex align-items-center"
            right
            size="sm"
          >
            <template #button-content>
              <feather-icon icon="MoreHorizontalIcon" size="14" class="mr-50" />
              Dropdown
            </template>
            <b-dropdown-item @click="payNow(data.item)">
              <feather-icon icon="ZapIcon" size="14" class="mr-50" />
              Pay Now
            </b-dropdown-item>
            <b-dropdown-item @click="checkBalance(data.item)">
              <feather-icon icon="DollarSignIcon" size="14" class="mr-50" />
              Check Balance
            </b-dropdown-item>
            <b-dropdown-item @click="setLimitMethod(data.item)">
              <feather-icon icon="SlidersIcon" size="14" class="mr-50" />
              Set Limit
            </b-dropdown-item>
            <b-dropdown-item @click="openLimitSetHistory(data.item)">
              <feather-icon icon="ClockIcon" size="14" class="mr-50" />
              Limit Set History
            </b-dropdown-item>
            <b-dropdown-item @click="openResendModal(data.item)">
              <feather-icon icon="MailIcon" size="14" class="mr-50" />
              Resend Password
            </b-dropdown-item>
            <b-dropdown-item @click="openPasswordModal(data.item)">
              <feather-icon icon="KeyIcon" size="14" class="mr-50" />
              Change Password
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <b-row class="mt-2" v-if="mimetalkLimit > 0 && mimetalkTotalCount > mimetalkLimit">
        <b-col cols="12" class="d-flex justify-content-center">
          <b-pagination
            v-model="mimetalkPage"
            :total-rows="mimetalkTotalCount"
            :per-page="mimetalkLimit"
            align="center"
            first-number
            last-number
            @input="onMimetalkPageChange"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <div class="row">
      <div class="col-12 col-lg-6">
        <b-card>
          <div class="md">
            <h3 class="mt-10">How to Pay for MiME Internet from Selfcare</h3>
            <video class="responsive-video" width="100%" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
          </div>
        </b-card>
      </div>
    </div>

    <!-- CDR Modal -->

    <b-modal
      id="cdrModal"
      title="Search CDRs"
      size="xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row>
        <b-col md="2">
          <label>From Date</label>

          <flat-pickr
            v-model="cdrFilter.from_date"
            :config="date_config"
            class="form-control"
          />
        </b-col>

        <b-col md="2">
          <label>To Date</label>

          <flat-pickr
            v-model="cdrFilter.to_date"
            :config="date_config"
            class="form-control"
          />
        </b-col>

        <b-col md="2">
          <label>SIP Number</label>

          <b-form-select v-model="cdrFilter.sip_number">
            <option value="">Select SIP</option>

            <option
              v-for="sip in sipnumbers"
              :key="sip.sip_number"
              :value="sip.sip_number"
            >
              {{ sip.sip_number }}
            </option>
          </b-form-select>
        </b-col>

        <b-col md="2">
          <label>Search</label>

          <b-form-input
                v-model="cdrFilter.search"
                type="text"
                class="form-control"
                placeholder="Search"
              />
        </b-col>

        <b-col md="3" class="mt-2">
          <b-button variant="info" class="mr-1" @click="searchCdr"> Search </b-button>
          <b-button variant="dark" @click="resetCdrModal"> Clear </b-button>

          <b-button
            v-if="cdrResults.length"
            variant="success"
            class="ml-2"
            @click="exportExcel"
          >
            Export Excel
          </b-button>
        </b-col>
      </b-row>

      <hr />

       <!-- Statistics Cards -->
      <b-row v-if="filteredCdrResults.length" class="mb-3">
        <b-col md="4">
          <b-card bg-variant="info" text-variant="white" class="text-center">
            <h5>Total Calls</h5>
            <h3>{{ cdrStatistics.totalCalls }}</h3>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card bg-variant="success" text-variant="white" class="text-center">
            <h5>Total Duration</h5>
            <h3>{{ cdrStatistics.totalDuration }}</h3>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card bg-variant="warning" text-variant="white" class="text-center">
            <h5>Total Cost</h5>
            <h3>{{ cdrStatistics.totalCost }} BDT</h3>
          </b-card>
        </b-col>
      </b-row>

        <!-- No results message -->
      <b-alert
        v-if="cdrResults.length && !filteredCdrResults.length"
        show
        variant="warning"
      >
        No matching records found for "{{ cdrFilter.search }}"
      </b-alert>

      <b-table
        v-if="filteredCdrResults.length"
        :items="pagedCdr"
        :fields="cdrFields"
        small
        responsive
        striped
        hover
      >
        <template #cell(sl_no)="row">
          {{ (currentPage - 1) * perPage + row.index + 1 }}
        </template>
      </b-table>

      <b-pagination
        v-if="filteredCdrResults.length"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="mt-2"
        align="center"
      />
    </b-modal>
    <!-- Balance Modal -->
    <b-modal
      id="balanceModal"
      :title="'Balance Information'"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <p><strong>Balance:</strong> {{ balance }} BDT</p>
      <b-table :items="transactions" :fields="transactionFields" small responsive />
    </b-modal>

    <!-- Payment Modal -->
    <b-modal
      id="payModal"
      :title="'Transfer Balance'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <validation-observer ref="formBalanceRules">
        <b-form @submit.prevent="submitPayment">
          <b-form-group label="SIP Number">
            <b-form-input v-model="paymentData.sip_number" readonly />
          </b-form-group>

          <b-form-group label="Amount">
            <validation-provider #default="{ errors }" name="Amount" rules="required|min_value:1">
              <b-form-input
                type="number"
                min="1"
                step="any"
                v-model="paymentData.transfer_balance_amount"
                placeholder="Enter amount"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <span class="text-danger text-sm" v-if="be_errors['transfer_balance_amount']">
              <small>{{ be_errors["transfer_balance_amount"][0] }}</small>
            </span>
          </b-form-group>

          <b-button variant="success" type="submit" class="mr-2"> Submit </b-button>

          <b-button variant="secondary" @click="$bvModal.hide('payModal')">
            Cancel
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Set Limit -->
    <b-modal
      id="mimetalkSetLimitModal"
      :title="'Set Limit (' + currentSipNumber + ')'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <validation-observer ref="formSetLimitRules">
        <b-form @submit.prevent="submitSetLimit">
          <b-form-group label="Enter a Positive Integer Limit">
            <validation-provider #default="{ errors }" name="limit" rules="required|min_value:1">
              <b-form-input
                type="number"
                min="1"
                step="1"
                v-model="setLimitData.limit"
                placeholder="Set Limit"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <span class="text-danger text-sm" v-if="be_errors['limit']">
              <small>{{ be_errors["limit"][0] }}</small>
            </span>
          </b-form-group>

          <b-button variant="success" type="submit" class="mr-2 d-inline-flex align-items-center">
            <feather-icon icon="CheckIcon" size="14" class="mr-50" />
            Submit
          </b-button>
          <b-button variant="secondary" class="d-inline-flex align-items-center" @click="$bvModal.hide('mimetalkSetLimitModal')">
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Limit Set History Modal -->
    <b-modal
      id="mimetalkLimitSetHistoryModal"
      :title="'Limit Set History (' + currentSipNumber + ')'"
      size="xl"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      @hidden="limitSetHistoryLineId = null"
    >
      <line-limit-set-history
        :line-id="limitSetHistoryLineId"
        :customer-id="userData && userData.username"
        customer-id-param="customer_id"
        endpoint="/api/v1/mimetalk_line_limit_set_history/"
        :show-source-column="true"
      />
      <b-button
        variant="secondary"
        class="d-inline-flex align-items-center mt-1"
        @click="$bvModal.hide('mimetalkLimitSetHistoryModal')"
      >
        <feather-icon icon="XIcon" size="14" class="mr-50" />
        Close
      </b-button>
    </b-modal>

    <!-- Password Change Modal -->
    <b-modal
      id="passwordModal"
      :title="'Change Password (' + currentSipNumber + ')'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <validation-observer ref="formPasswordRules">
        <b-form @submit.prevent="submitPassword">
          <b-form-group label="New Password *">
            <validation-provider
              #default="{ errors }"
              name="Service Type"
              rules="required"
            >
              <b-form-input
                type="password"
                v-model="passwordForm.new_password"
                placeholder="Enter new password"
                rules="required"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <span class="text-danger text-sm" v-if="be_errors['new_password']">
              <small>{{ be_errors["new_password"][0] }}</small>
            </span>
          </b-form-group>

          <div class="mb-2">
            <div :class="validations.min ? 'text-success' : 'text-danger'">
              ✓ Minimum 8 characters
            </div>

            <div :class="validations.max ? 'text-success' : 'text-danger'">
              ✓ Maximum 20 characters
            </div>

            <div :class="validations.upper ? 'text-success' : 'text-danger'">
              ✓ At least 1 uppercase letter
            </div>

            <div :class="validations.lower ? 'text-success' : 'text-danger'">
              ✓ At least 1 lowercase letter
            </div>

            <div :class="validations.number ? 'text-success' : 'text-danger'">
              ✓ At least 1 number
            </div>

            <div :class="validations.special ? 'text-success' : 'text-danger'">
              ✓ At least 1 special character (!@#$%^&*)
            </div>
          </div>

          <b-button
            variant="secondary"
            class="mr-2"
            @click="$bvModal.hide('passwordModal')"
          >
            Close
          </b-button>

          <b-button variant="primary" type="submit" :disabled="!isPasswordValid">
            Submit
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Bulk Recharge Modal -->
    <b-modal
      id="mimetalkBulkRechargeModal"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="p-0"
      content-class="bulk-modal-content"
    >
      <div class="bulk-modal-wrapper">
        <div class="bm-header">
          <div class="bm-header-left">
            <div class="bm-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="2" y="4" width="12" height="9" rx="1.5" stroke="#185FA5" stroke-width="1.2"/>
                <path d="M5 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" stroke="#185FA5" stroke-width="1.2"/>
                <circle cx="8" cy="8.5" r="1.5" fill="#185FA5"/>
              </svg>
            </div>
            <div>
              <p class="bm-title">Bulk Recharge</p>
              <p class="bm-subtitle">
                {{ bulkRechargeProgressing ? 'Processing recharge…' : 'Review and confirm all lines' }}
              </p>
            </div>
          </div>
          <button
            class="bm-close-btn"
            :disabled="bulkRechargeProgressing"
            @click="closeBulkRechargeModal"
          >&#x2715;</button>
        </div>

        <div class="bm-body">
          <div v-if="bulkRechargeProgressing" class="bm-progress">
            <p class="bm-progress-label">
              Recharging lines…
              <span v-if="bulkRechargeTotalCount">
                {{ bulkRechargeCompletedCount }} / {{ bulkRechargeTotalCount }}
              </span>
            </p>
            <b-progress
              :value="bulkRechargeProgress"
              :max="100"
              height="1.25rem"
              animated
              show-progress
              variant="primary"
              class="bm-progress-bar"
            ></b-progress>
            <p class="bm-progress-hint">Please wait while the recharge completes. Do not close this window.</p>
          </div>

          <div v-else-if="bulkRechargePreview.length">
            <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap" style="gap: 0.5rem;">
              <div class="d-flex align-items-center" style="gap: 0.5rem;">
                <span class="text-muted" style="font-size: 13px;">Per Page</span>
                <b-form-select
                  v-model="bulkRechargePreviewLimit"
                  :options="bulkRechargePreviewLimitOptions"
                  size="sm"
                  class="did-limit-select"
                  @change="onBulkRechargePreviewLimitChange"
                />
                <span class="text-muted" style="font-size: 13px;">
                  {{ bulkRechargePreviewTotalCount }} line(s)
                </span>
              </div>
              <div class="d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
                <span class="" style="font-size: 13px;">Recharge Amount</span>
                <b-form-select
                  v-model="bulkRechargeAmountMode"
                  :options="bulkRechargeAmountModeOptions"
                  size="sm"
                  class="did-limit-select"
                  @change="onBulkRechargeModeChange"
                />
                <span
                  v-if="bulkRechargeAmountMode === 'consumed'"
                  class="text-muted"
                  style="font-size: 12px;"
                >
                  (Limit &minus; Balance, min 0)
                </span>
              </div>
            </div>
            <div class="bm-table-wrapper">
              <table class="bm-table">
                <thead>
                  <tr>
                    <th class="text-left">Number</th>
                    <th class="text-left">MiME Talk Number</th>
                    <th class="text-right">Limit (Tk)</th>
                    <th class="text-right">Balance (Tk)</th>
                    <th class="text-right">Amount to Recharge (Tk)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in bulkRechargePagedRows"
                    :key="`${item.sip_number}-${index}`"
                  >
                    <td class="bm-mono">{{ item.mobile_number }}</td>
                    <td class="bm-mono">{{ item.sip_number }}</td>
                    <td class="text-right bm-muted">{{ item.limit != null ? item.limit : '-' }}</td>
                    <td class="text-right bm-muted">{{ item.balance != null ? item.balance : '-' }}</td>
                    <td class="text-right bm-amount">
                      <b-form-input
                        type="number"
                        min="0"
                        :max="getBulkRechargeAmountMax(item)"
                        size="sm"
                        :class="[
                          'bm-amount-input',
                          { 'is-invalid': isBulkRechargeAmountOverLimit(item) },
                        ]"
                        :value="effectiveRechargeAmount(item)"
                        :disabled="bulkRechargeProgressing || bulkRechargeSubmitting"
                        @input.native="onBulkRechargeAmountNativeInput(item, $event)"
                        @keydown.native="onBulkRechargeAmountKeydown(item, $event)"
                        @paste.native="onBulkRechargeAmountPaste(item, $event)"
                      />
                      <div
                        v-if="isBulkRechargeAmountOverLimit(item)"
                        class="bm-amount-error"
                      >
                        Cannot exceed limit ({{ item.limit }})
                      </div>
                      <div
                        v-else-if="bulkRechargeAmountMode === 'default' && !hasManualAmountEdit(item) && isDefaultLimitRecharge(item)"
                        class="bm-default-limit"
                      >
                        (Limit Amount)
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="bm-total-label">Total</td>
                    <td class="text-right bm-total-value">{{ bulkRechargeDisplayTotal }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="d-flex justify-content-center mt-2" v-if="bulkRechargePreviewTotalCount > bulkRechargePreviewLimit">
              <b-pagination
                v-model="bulkRechargePreviewPage"
                :total-rows="bulkRechargePreviewTotalCount"
                :per-page="bulkRechargePreviewLimit"
                align="center"
                first-number
                last-number
              ></b-pagination>
            </div>

            <div class="bm-warning">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="bm-warning-icon">
                <circle cx="8" cy="8" r="6.5" stroke="#92640A" stroke-width="1.2"/>
                <path d="M8 5v3.5" stroke="#92640A" stroke-width="1.2" stroke-linecap="round"/>
                <circle cx="8" cy="11" r="0.7" fill="#92640A"/>
              </svg>
              <p class="bm-warning-text">
                This will recharge <strong>{{ bulkRechargeDisplayTotal }}</strong> across
                {{ bulkRechargePreviewTotalCount }} selected lines. This action cannot be undone.
              </p>
            </div>
          </div>

          <div v-else class="bm-loading">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
            <p class="bm-loading-text">Loading preview data...</p>
          </div>
        </div>

        <div v-if="!bulkRechargeProgressing" class="bm-footer">
          <button
            class="bm-btn bm-btn-cancel d-inline-flex align-items-center"
            @click="closeBulkRechargeModal"
          >
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </button>
          <button
            class="bm-btn bm-btn-confirm d-inline-flex align-items-center"
            :disabled="!bulkRechargePreview.length || bulkRechargeSubmitting || hasBulkRechargeAmountOverLimit"
            @click="submitBulkRecharge"
          >
            <b-spinner small v-if="bulkRechargeSubmitting"></b-spinner>
            <feather-icon v-else icon="CheckIcon" size="14" class="mr-50 text-white" />
            Confirm recharge
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Bulk Set Limit Modal -->
    <b-modal
      id="mimetalkBulkSetLimitModal"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="p-0"
      content-class="bulk-modal-content"
    >
      <div class="bulk-modal-wrapper">
        <div class="bm-header">
          <div class="bm-header-left">
            <div class="bm-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="2" y="4" width="12" height="9" rx="1.5" stroke="#185FA5" stroke-width="1.2"/>
                <path d="M5 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" stroke="#185FA5" stroke-width="1.2"/>
                <circle cx="8" cy="8.5" r="1.5" fill="#185FA5"/>
              </svg>
            </div>
            <div>
              <p class="bm-title">Bulk Set Limit</p>
              <p class="bm-subtitle">Review and confirm all lines</p>
            </div>
          </div>
          <button
            class="bm-close-btn"
            :disabled="bulkSetLimitSubmitting"
            @click="closeBulkSetLimitModal"
          >&#x2715;</button>
        </div>

        <div class="bm-body">
          <div v-if="bulkSetLimitPreview.length">
            <div class="bm-table-wrapper">
              <table class="bm-table">
                <thead>
                  <tr>
                    <th class="text-left">Number</th>
                    <th class="text-left">MiME Talk Number</th>
                    <th class="text-right">Limit (Tk)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in bulkSetLimitPreview" :key="index">
                    <td class="bm-mono">{{ item.mobile_number }}</td>
                    <td class="bm-mono">{{ item.sip_number }}</td>
                    <td class="text-right bm-amount">{{ item.limit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="bm-warning">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="bm-warning-icon">
                <circle cx="8" cy="8" r="6.5" stroke="#92640A" stroke-width="1.2"/>
                <path d="M8 5v3.5" stroke="#92640A" stroke-width="1.2" stroke-linecap="round"/>
                <circle cx="8" cy="11" r="0.7" fill="#92640A"/>
              </svg>
              <p class="bm-warning-text">
                This will update limits for
                <strong>{{ bulkSetLimitPreview.length }}</strong> selected lines. This action cannot be undone.
              </p>
            </div>
          </div>

          <div v-else class="bm-loading">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
            <p class="bm-loading-text">Loading preview data...</p>
          </div>
        </div>

        <div class="bm-footer">
          <button
            class="bm-btn bm-btn-cancel d-inline-flex align-items-center"
            :disabled="bulkSetLimitSubmitting"
            @click="closeBulkSetLimitModal"
          >
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </button>
          <button
            class="bm-btn bm-btn-confirm d-inline-flex align-items-center"
            :disabled="!bulkSetLimitPreview.length || bulkSetLimitSubmitting"
            @click="submitBulkSetLimit"
          >
            <b-spinner small v-if="bulkSetLimitSubmitting"></b-spinner>
            <feather-icon v-else icon="CheckIcon" size="14" class="mr-50 text-white" />
            Confirm set limit
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Download Summary Modal -->
    <b-modal
      id="mimetalkDownloadSummaryModal"
      size="md"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="p-0"
      content-class="ds-modal-content"
    >
      <div class="ds-wrapper">
        <div class="ds-header">
          <div class="ds-header-left">
            <div class="ds-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 2v8M5 7l3 3 3-3" stroke="#0F6E56" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 12h10" stroke="#0F6E56" stroke-width="1.3" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <p class="ds-title">Download Summary</p>
              <p class="ds-subtitle">Export data as Excel spreadsheet</p>
            </div>
          </div>
          <button class="ds-close-btn" @click="$bvModal.hide('mimetalkDownloadSummaryModal')">&#x2715;</button>
        </div>

        <div class="ds-body">
          <validation-observer ref="summaryRules">
            <b-form @submit.prevent="downloadSummary">
              <div class="ds-date-grid">
                <div class="ds-field">
                  <label class="ds-label">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <rect x="1" y="2" width="10" height="9" rx="1.2" stroke="currentColor" stroke-width="1.1"/>
                      <path d="M4 1v2M8 1v2M1 5h10" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
                    </svg>
                    From date
                  </label>
                  <validation-provider #default="{ errors }" name="From Date" rules="required">
                    <div :class="['ds-input-wrap', { 'ds-input-error': errors[0] }]">
                      <flat-pickr
                        v-model="summaryFilters.from_date"
                        :config="summaryDateConfig.fromDate"
                        class="ds-input ds-summary-date"
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                    <span class="ds-error" v-if="errors[0]">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <circle cx="5.5" cy="5.5" r="4.5" stroke="#A32D2D" stroke-width="1"/>
                        <path d="M5.5 3.5v2.5" stroke="#A32D2D" stroke-width="1" stroke-linecap="round"/>
                        <circle cx="5.5" cy="7.5" r="0.5" fill="#A32D2D"/>
                      </svg>
                      {{ errors[0] }}
                    </span>
                  </validation-provider>
                </div>

                <div class="ds-field">
                  <label class="ds-label">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <rect x="1" y="2" width="10" height="9" rx="1.2" stroke="currentColor" stroke-width="1.1"/>
                      <path d="M4 1v2M8 1v2M1 5h10" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
                    </svg>
                    To date
                  </label>
                  <validation-provider #default="{ errors }" name="To Date" rules="required">
                    <div :class="['ds-input-wrap', { 'ds-input-error': errors[0] }]">
                      <flat-pickr
                        v-model="summaryFilters.to_date"
                        :config="summaryDateConfig.toDate"
                        class="ds-input ds-summary-date"
                        placeholder="dd/mm/yyyy"
                      />
                    </div>
                    <span class="ds-error" v-if="errors[0]">
                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <circle cx="5.5" cy="5.5" r="4.5" stroke="#A32D2D" stroke-width="1"/>
                        <path d="M5.5 3.5v2.5" stroke="#A32D2D" stroke-width="1" stroke-linecap="round"/>
                        <circle cx="5.5" cy="7.5" r="0.5" fill="#A32D2D"/>
                      </svg>
                      {{ errors[0] }}
                    </span>
                  </validation-provider>
                </div>
              </div>

              <div class="ds-lines-badge" v-if="selectedRows.length">
                <div class="ds-lines-left">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <rect x="1" y="1" width="12" height="12" rx="2" stroke="#185FA5" stroke-width="1.1"/>
                    <path d="M4 7h6M4 4.5h6M4 9.5h4" stroke="#185FA5" stroke-width="1.1" stroke-linecap="round"/>
                  </svg>
                  <span class="ds-lines-label">Selected MiME Talk lines</span>
                </div>
                <span class="ds-lines-count">{{ selectedRows.length }} lines</span>
              </div>

              <div class="ds-info">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="ds-info-icon">
                  <circle cx="6.5" cy="6.5" r="5.5" stroke="#185FA5" stroke-width="1"/>
                  <path d="M6.5 5.5v4" stroke="#185FA5" stroke-width="1" stroke-linecap="round"/>
                  <circle cx="6.5" cy="4" r="0.6" fill="#185FA5"/>
                </svg>
                <p class="ds-info-text">The exported file will include usage summary records within the selected date range.</p>
              </div>

              <div class="ds-actions">
                <button
                  type="button"
                  class="ds-btn ds-btn-cancel d-inline-flex align-items-center"
                  @click="$bvModal.hide('mimetalkDownloadSummaryModal')"
                >
                  <feather-icon icon="XIcon" size="14" class="mr-50" />
                  Cancel
                </button>
                <button
                  type="submit"
                  class="ds-btn ds-btn-download d-inline-flex align-items-center"
                  :disabled="downloading"
                >
                  <b-spinner small v-if="downloading"></b-spinner>
                  <feather-icon v-else icon="DownloadIcon" size="14" class="mr-50 text-white" />
                  Download Excel
                </button>
              </div>
            </b-form>
          </validation-observer>
        </div>
      </div>
    </b-modal>

    <!-- Bulk Selection Modal -->
    <b-modal
      id="mimetalkBulkSelectionModal"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      header-class="bulk-selection-modal-header"
      @hidden="resetBulkSelectionModal"
    >
      <template #modal-header="{ close }">
        <div class="w-100 bulk-selection-modal-header-inner">
          <h5 class="modal-title mb-0">Bulk Selection</h5>
          <div class="bulk-selection-modal-header-actions">
            <b-button
              size="sm"
              variant="success"
              class="d-inline-flex align-items-center justify-content-center"
              as="a"
              href="/BulkSipSelection_Sample.xlsx"
              download
            >
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Download Demo File
            </b-button>
            <button type="button" aria-label="Close" class="close" @click="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div class="d-flex align-items-end bulk-selection-upload-row">
        <b-form-group label="Upload Excel File" class="flex-grow-1 mb-0 mr-2">
          <b-form-file
            v-model="bulkSelectionFile"
            accept=".xlsx, .xls"
            placeholder="Choose Excel file..."
            @input="onBulkSelectionFileSelected"
          ></b-form-file>
        </b-form-group>
        <b-button
          variant="info"
          class="flex-shrink-0 d-inline-flex align-items-center mt-2"
          :disabled="!bulkSelectionFile"
          @click="uploadBulkSelection"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Upload
        </b-button>
      </div>
      <small class="form-text text-muted d-block mb-0">
        Excel should have columns: mime_talk_number, recharge_amount (optional)
      </small>

      <div
        v-if="bulkSelectionBlocked.length"
        class="bulk-selection-unmatched alert alert-secondary mt-3 mb-0"
      >
        <p class="bulk-selection-unmatched-title mb-2">
          {{ bulkSelectionBlocked.length }} number(s) skipped (inactive/blocked)
        </p>
        <div class="bulk-selection-unmatched-list">
          <span
            v-for="(number, index) in bulkSelectionBlocked"
            :key="`blocked-${number}-${index}`"
            class="bulk-selection-unmatched-chip"
          >
            {{ number }}
          </span>
        </div>
      </div>

      <div
        v-if="bulkSelectionInvalidAmounts.length"
        class="bulk-selection-unmatched alert alert-danger mt-3 mb-0"
      >
        <p class="bulk-selection-unmatched-title mb-2">
          {{ bulkSelectionInvalidAmounts.length }} row(s) have invalid recharge amount
        </p>
        <div class="bulk-selection-unmatched-list">
          <span
            v-for="(row, index) in bulkSelectionInvalidAmounts"
            :key="`${row.sip_number}-${index}`"
            class="bulk-selection-unmatched-chip"
          >
            {{ row.sip_number }} ({{ row.recharge_amount }})
          </span>
        </div>
      </div>

      <div
        v-if="bulkSelectionUnmatched.length"
        class="bulk-selection-unmatched alert alert-warning mt-3 mb-0"
      >
        <p class="bulk-selection-unmatched-title mb-2">
          {{ bulkSelectionUnmatched.length }} number(s) not found
        </p>
        <div class="bulk-selection-unmatched-list">
          <span
            v-for="(number, index) in bulkSelectionUnmatched"
            :key="`${number}-${index}`"
            class="bulk-selection-unmatched-chip"
          >
            {{ number }}
          </span>
        </div>
      </div>

      <div v-if="bulkSelectionMatched.length" class="mt-3">
        <b-table
          responsive
          small
          class="bulk-selection-matched-table"
          :items="bulkSelectionMatched"
          :fields="bulkSelectionDisplayFields"
          show-empty
          empty-text="No matched numbers"
        >
          <template #cell(sl)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(recharge_amount)="data">
            <span v-if="hasExcelRechargeAmount(data.item.recharge_amount)">
              {{ data.item.recharge_amount }}
            </span>
          </template>
          <template #cell(action)="data">
            <b-button
              size="sm"
              variant="danger"
              class="d-inline-flex align-items-center"
              @click="removeBulkSelectionRow(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" size="14" class="mr-50" />
              Delete
            </b-button>
          </template>
        </b-table>

        <div class="bulk-selection-footer-actions mt-3">
          <b-button
            variant="secondary"
            class="d-inline-flex align-items-center justify-content-center"
            @click="closeBulkSelectionModal"
          >
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </b-button>
          <b-button
            variant="warning"
            class="d-inline-flex align-items-center justify-content-center"
            :disabled="!bulkSelectionMatched.length"
            @click="submitBulkSelectionRecharge"
          >
            <feather-icon icon="ArrowRightIcon" size="14" class="mr-50" />
            Next
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Confirmation Modal -->
    <b-modal
      id="resend-modal"
      :title="'Confirm Resend (' + currentSipNumber + ')'"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <p>
        Are you sure you want to resend the password?
      </p>

      <div class="text-right">
        <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('resend-modal')">
          No
        </b-button>

        <b-button variant="warning" @click="confirmResend"> Yes </b-button>
      </div>
    </b-modal>

    <!-- Bulk Set Limit Selection Modal -->
    <b-modal
      id="mimetalkBulkSetLimitSelectionModal"
      size="lg"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      header-class="bulk-selection-modal-header"
      @hidden="resetBulkSetLimitSelectionModal"
    >
      <template #modal-header="{ close }">
        <div class="w-100 bulk-selection-modal-header-inner">
          <h5 class="modal-title mb-0">Bulk Set Limit Selection</h5>
          <div class="bulk-selection-modal-header-actions">
            <b-button
              size="sm"
              variant="success"
              class="d-inline-flex align-items-center justify-content-center"
              as="a"
              href="/BulkSipSetLimit_Sample.xlsx"
              download
            >
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Download Demo File
            </b-button>
            <button type="button" aria-label="Close" class="close" @click="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div class="d-flex align-items-end bulk-selection-upload-row">
        <b-form-group label="Upload Excel File" class="flex-grow-1 mb-0 mr-2">
          <b-form-file
            v-model="bulkSetLimitSelectionFile"
            accept=".xlsx, .xls"
            placeholder="Choose Excel file..."
            @input="onBulkSetLimitSelectionFileSelected"
          ></b-form-file>
        </b-form-group>
        <b-button
          variant="info"
          class="flex-shrink-0 d-inline-flex align-items-center mt-2"
          :disabled="!bulkSetLimitSelectionFile"
          @click="uploadBulkSetLimitSelection"
        >
          <feather-icon icon="UploadIcon" size="14" class="mr-50" />
          Upload
        </b-button>
      </div>
      <small class="form-text text-muted d-block mb-0">
        Excel should have columns: sip_number, limit
      </small>

      <div
        v-if="bulkSetLimitSelectionUnmatched.length"
        class="bulk-selection-unmatched alert alert-warning mt-3 mb-0"
      >
        <p class="bulk-selection-unmatched-title mb-2">
          {{ bulkSetLimitSelectionUnmatched.length }} number(s) not found
        </p>
        <div class="bulk-selection-unmatched-list">
          <span
            v-for="(number, index) in bulkSetLimitSelectionUnmatched"
            :key="`${number}-${index}`"
            class="bulk-selection-unmatched-chip"
          >
            {{ number }}
          </span>
        </div>
      </div>

      <div v-if="bulkSetLimitSelectionInvalid.length" class="alert alert-danger mt-3 mb-0">
        <p class="mb-2">{{ bulkSetLimitSelectionInvalid.length }} row(s) have invalid limit</p>
        <div class="bulk-selection-unmatched-list">
          <span
            v-for="(row, index) in bulkSetLimitSelectionInvalid"
            :key="`${row.sip_number}-${index}`"
            class="bulk-selection-unmatched-chip"
          >
            {{ row.sip_number }} ({{ row.limit }})
          </span>
        </div>
      </div>

      <div v-if="bulkSetLimitSelectionMatched.length" class="mt-3">
        <b-table
          responsive
          small
          :items="bulkSetLimitSelectionMatched"
          :fields="bulkSetLimitSelectionFields"
          show-empty
          empty-text="No matched numbers"
        >
          <template #cell(sl)="data">
            {{ data.index + 1 }}
          </template>
        </b-table>

        <div class="bulk-selection-footer-actions mt-3">
          <b-button
            variant="secondary"
            class="d-inline-flex align-items-center justify-content-center"
            @click="closeBulkSetLimitSelectionModal"
          >
            <feather-icon icon="XIcon" size="14" class="mr-50" />
            Cancel
          </b-button>
          <b-button
            variant="warning"
            class="d-inline-flex align-items-center justify-content-center"
            :disabled="!bulkSetLimitSelectionMatched.length"
            @click="submitBulkSetLimitSelection"
          >
            <feather-icon icon="SlidersIcon" size="14" class="mr-50" />
            Bulk Set Limit
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BModal,
  BBadge,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BPagination,
  BAlert,
  BFormCheckbox,
  BFormFile,
  BSpinner,
  BProgress,
} from "bootstrap-vue";

import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, min_value } from "vee-validate/dist/rules";
extend("required", required);
extend("min_value", min_value);
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

import api from "@/services/api";
import { decrypt } from "@/utils/crypto";
import LineLimitSetHistory from "./LineLimitSetHistory.vue";

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BDropdown,
    BDropdownItem,
    BModal,
    BBadge,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BPagination,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BAlert,
    BFormCheckbox,
    BFormFile,
    BSpinner,
    BProgress,
    LineLimitSetHistory,
  },

  data() {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userData = decrypt(localStorage.getItem("userData"));

    return {
      userDetails,
      userData,
      sipnumbers: [],
      mimetalkSearchQuery: "",
      mimetalkSearchTimer: null,
      mimetalkPage: 1,
      mimetalkLimit: 10,
      mimetalkLimitOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 500, text: '500' },
        { value: -1, text: 'All' },
      ],
      mimetalkTotalCount: 0,
      mimetalkStatusFilter: "",
      mimetalkStatusFilterOptions: [
        { value: "", text: "Select Block Status" },
        { value: "unblocked", text: "Active" },
        { value: "blocked", text: "Inactive" },
      ],
      mimetalkHasLimit: "",
      mimetalkHasLimitOptions: [
        { value: "", text: "Select Limit Status" },
        { value: "yes", text: "Limit Set" },
        { value: "no", text: "Limit Not Set" },
      ],
      selectedLinesData: [],
      cdrResults: [],
      balance: 0,
      transactions: [],
      selectedItem: null,
      currentSipNumber: "",
      limitSetHistoryLineId: null,
      selectedRows: [],
      be_errors: {},
      currentPage: 1,
      perPage: 25,

      date_config: {
        enableTime: true,
        enableSeconds: true,
        time_24hr: true,
        dateFormat: "d/m/Y H:i:S",
      },
      videoUrl: "/documents/How_to_Pay_for_MiME_Internet_from_Selfcare.mp4",
      passwordForm: {
        id: null,
        new_password: "",
      },
      cdrFilter: {
        sip_number: "",
        from_date: "",
        to_date: "",
        search: "",
      },
      paymentData: {
        sip_number: "",
        transfer_balance_amount: "",
      },
      setLimitData: {
        id: null,
        limit: 0,
        originalLimit: 0,
      },
      bulkRechargePreview: [],
      bulkRechargeTotal: 0,
      bulkRechargePreviewPage: 1,
      bulkRechargePreviewLimit: 10,
      bulkRechargePreviewLimitOptions: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
      ],
      bulkRechargePreviewTotalCount: 0,
      bulkRechargeSubmitting: false,
      bulkRechargeProgressing: false,
      bulkRechargeProgress: 0,
      bulkRechargeJobId: null,
      bulkRechargePollTimer: null,
      bulkRechargeCompletedCount: 0,
      bulkRechargeTotalCount: 0,
      bulkSelectionFile: null,
      bulkSelectionMatched: [],
      bulkSelectionUnmatched: [],
      bulkSelectionBlocked: [],
      bulkSelectionInvalidAmounts: [],
      bulkRechargeAmountMap: {},
      bulkRechargeAmountMode: "default",
      bulkRechargeAmountModeOptions: [
        { value: "default", text: "Default" },
        { value: "limit", text: "Limit" },
        { value: "consumed", text: "Consumed Amount" },
      ],
      bulkRechargeEditedAmounts: {},
      bulkSetLimitSelectionFile: null,
      bulkSetLimitSelectionMatched: [],
      bulkSetLimitSelectionUnmatched: [],
      bulkSetLimitSelectionInvalid: [],
      bulkSetLimitSelectionFields: [
        { key: "sl", label: "SL", thStyle: { width: "5%" } },
        { key: "mobile_number", label: "Mobile Number" },
        { key: "sip_number", label: "MiME Talk Number" },
        { key: "limit", label: "Limit (Tk)" },
      ],
      bulkSetLimitPreview: [],
      bulkSetLimitSubmitting: false,
      bulkSetLimitPendingLines: [],
      downloading: false,
      summaryFilters: {
        from_date: moment().startOf("month").format("YYYY-MM-DD"),
        to_date: moment().format("YYYY-MM-DD"),
      },
      summaryDateConfig: {
        fromDate: {
          altFormat: "d/m/Y",
          altInput: true,
          dateFormat: "Y-m-d",
        },
        toDate: {
          altFormat: "d/m/Y",
          altInput: true,
          dateFormat: "Y-m-d",
          minDate: null,
        },
      },

      fields: [
        { key: "select", label: "", tdClass: "align-middle" },
        { key: "sl", label: "#" },
        { key: "mobile_number", label: "Mobile Number" },
        { key: "sip_number", label: "MiME Talk Number" },
        { key: "package_name", label: "Package Name" },
        { key: "limit", label: "Limit (Tk)" },
        { key: "balance", label: "Balance (Tk)" },
        { key: "block_status", label: "Block Status" },
        { key: "action", label: "Action" },
      ],

      cdrFields: [
        { key: "sl_no", label: "Sl No.", sortable: true },
        { key: "cli", label: "Caller", sortable: true },
        { key: "cld", label: "Callee", sortable: true },
        { key: "connect_time", label: "Connect Time", sortable: true },
        { key: "disconnect_time", label: "Disconnect Time", sortable: true },
        { key: "billed_duration", label: "Duration", sortable: true },
        { key: "cost", label: "Cost", sortable: true },
        { key: "release_source", label: "Release Source", sortable: true },
        { key: "description", label: "Description", sortable: true },
      ],

      transactionFields: [
        { key: "i_payment", label: "Payment ID" },
        { key: "payment_time", label: "Date" },
        { key: "sip_number", label: "SIP Number" },
        { key: "amount", label: "Amount" },
        { key: "currency", label: "Currency" },
      ],
    };
  },

  watch: {
    "summaryFilters.from_date"(newVal) {
      this.summaryDateConfig.toDate.minDate = newVal || null;
      if (
        newVal &&
        this.summaryFilters.to_date &&
        moment(this.summaryFilters.to_date).isBefore(moment(newVal), "day")
      ) {
        this.summaryFilters.to_date = newVal;
      }
    },
  },

  computed: {
    validations() {
      const p = this.passwordForm.new_password;

      return {
        min: p.length >= 8,
        max: p.length <= 20,
        upper: /[A-Z]/.test(p),
        lower: /[a-z]/.test(p),
        number: /[0-9]/.test(p),
        special: /[!@#$%^&*]/.test(p),
      };
    },

    isPasswordValid() {
      const v = this.validations;

      return v.min && v.max && v.upper && v.lower && v.number && v.special;
    },

    filteredCdrResults() {
      if (!this.cdrFilter.search) {
        return this.cdrResults;
      }
      
      const searchTerm = this.cdrFilter.search.toLowerCase().trim();
      
      return this.cdrResults.filter(cdr => {
        // Search through all relevant fields
        return (
          (cdr.cli && cdr.cli.toLowerCase().includes(searchTerm)) ||
          (cdr.cld && cdr.cld.toLowerCase().includes(searchTerm)) ||
          (cdr.connect_time && cdr.connect_time.toLowerCase().includes(searchTerm)) ||
          (cdr.disconnect_time && cdr.disconnect_time.toLowerCase().includes(searchTerm)) ||
          (cdr.billed_duration && cdr.billed_duration.toString().includes(searchTerm)) ||
          (cdr.cost && cdr.cost.toString().includes(searchTerm)) ||
          (cdr.release_source && cdr.release_source.toLowerCase().includes(searchTerm)) ||
          (cdr.description && cdr.description.toLowerCase().includes(searchTerm))
        );
      });
    },
    
    // Update paged data to use filtered results
    pagedCdr() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredCdrResults.slice(start, end);
    },
    
    // Calculate statistics
    cdrStatistics() {
      const filteredData = this.filteredCdrResults;
      
      // Total calls
      const totalCalls = filteredData.length;
      
      // Total duration (in seconds)
      let totalSeconds = 0;
      filteredData.forEach(cdr => {
        totalSeconds += parseFloat(cdr.billed_duration) || 0;
      });
      
      // Format total duration as HH:MM:SS or MM:SS
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = Math.floor(totalSeconds % 60);
      
      let totalDuration = '';
      if (hours > 0) {
        totalDuration = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        totalDuration = `${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
      
      // Total cost
      let totalCost = 0;
      filteredData.forEach(cdr => {
        totalCost += parseFloat(cdr.cost) || 0;
      });
      
      return {
        totalCalls,
        totalDuration,
        totalCost: totalCost.toFixed(3)
      };
    },
    
    // Update total rows for pagination
    totalRows() {
      return this.filteredCdrResults.length;
    },
    isAllSelected() {
      return this.sipnumbers.length > 0 && this.sipnumbers.every(item => this.selectedRows.includes(item.id));
    },
    mimetalkOffset() {
      if (this.mimetalkLimit === -1) return 0;
      return (this.mimetalkPage - 1) * this.mimetalkLimit;
    },
    bulkRechargePagedRows() {
      const start = (this.bulkRechargePreviewPage - 1) * this.bulkRechargePreviewLimit;
      const end = start + this.bulkRechargePreviewLimit;
      return this.bulkRechargePreview.slice(start, end);
    },
    bulkRechargeDisplayTotal() {
      const total = this.bulkRechargePreview.reduce(
        (sum, item) => sum + (Number(this.effectiveRechargeAmount(item)) || 0),
        0
      );
      return Math.round(total * 100) / 100;
    },
    bulkRechargeAmountsById() {
      const map = {};
      if (!this.bulkRechargePreview.length) return map;
      const hasEdits = Object.keys(this.bulkRechargeEditedAmounts).length > 0;
      if (this.bulkRechargeAmountMode === "default" && !hasEdits) return map;
      this.bulkRechargePreview.forEach((item) => {
        const key = this.normalizeSipNumber(item.sip_number);
        const line = this.sipnumbers.find(
          (sip) => this.normalizeSipNumber(sip.sip_number) === key
        );
        if (line) {
          map[line.id] = this.effectiveRechargeAmount(item);
        }
      });
      return map;
    },
    hasBulkRechargeAmountOverLimit() {
      return this.bulkRechargePreview.some((item) =>
        this.isBulkRechargeAmountOverLimit(item)
      );
    },
    bulkSelectionDisplayFields() {
      const showRecharge = this.bulkSelectionMatched.some(
        (item) => this.hasExcelRechargeAmount(item.recharge_amount)
      );
      const centerClass = "text-center align-middle";
      const fields = [
        {
          key: "sl",
          label: "SL",
          thStyle: { width: showRecharge ? "8%" : "12%" },
          thClass: centerClass,
          tdClass: centerClass,
        },
        {
          key: "sip_number",
          label: "MiME Talk Number",
          thStyle: { width: showRecharge ? "32%" : "58%" },
          thClass: centerClass,
          tdClass: centerClass,
        },
      ];
      if (showRecharge) {
        fields.push({
          key: "recharge_amount",
          label: "Recharge Amount (Tk)",
          thStyle: { width: "30%" },
          thClass: centerClass,
          tdClass: centerClass,
        });
      }
      fields.push({
        key: "action",
        label: "Action",
        thStyle: { width: showRecharge ? "15%" : "20%" },
        thClass: centerClass,
        tdClass: centerClass,
      });
      return fields;
    },
  },
  methods: {
    isSelected(id) {
      return this.selectedRows.includes(id);
    },

    toggleSelection(id) {
      if (this.isSelected(id)) {
        this.selectedRows = this.selectedRows.filter(rowId => rowId !== id);
        this.selectedLinesData = this.selectedLinesData.filter(item => item.id !== id);
      } else {
        this.selectedRows.push(id);
        const found = this.sipnumbers.find(item => item.id === id);
        if (found) {
          this.selectedLinesData.push({ id: found.id, limit: parseFloat(found.limit) || 0 });
        }
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        const currentPageIds = this.sipnumbers.map(item => item.id);
        this.selectedRows = this.selectedRows.filter(id => !currentPageIds.includes(id));
        this.selectedLinesData = this.selectedLinesData.filter(item => !currentPageIds.includes(item.id));
      } else {
        const newSelected = [...this.selectedRows];
        const newData = [...this.selectedLinesData];
        this.sipnumbers.forEach(item => {
          if (!newSelected.includes(item.id)) {
            newSelected.push(item.id);
            newData.push({ id: item.id, limit: parseFloat(item.limit) || 0 });
          }
        });
        this.selectedRows = newSelected;
        this.selectedLinesData = newData;
      }
    },

    onMimetalkSearchInput() {
      clearTimeout(this.mimetalkSearchTimer);
      this.mimetalkSearchTimer = setTimeout(() => {
        this.mimetalkPage = 1;
        this.fetchMimeTalkServices();
      }, 400);
    },

    onMimetalkLimitChange() {
      this.mimetalkPage = 1;
      this.fetchMimeTalkServices();
    },

    onMimetalkPageChange() {
      this.fetchMimeTalkServices();
    },

    onMimetalkStatusFilterChange() {
      this.mimetalkPage = 1;
      this.fetchMimeTalkServices();
    },

    onMimetalkHasLimitChange() {
      this.mimetalkPage = 1;
      this.fetchMimeTalkServices();
    },

    openCdrModal() {
      this.$bvModal.show("cdrModal");
    },

    async fetchMimeTalkServices() {
      const username = this.userData?.username;
      const loader = this.$showCustomLoader();
      try {
        let url = `/api/v1/iptsp/sipnumber/${username}/?search_for=all`;
        if (this.mimetalkLimit === -1) {
          url += `&limit=-1`;
        } else {
          url += `&limit=${this.mimetalkLimit}&offset=${this.mimetalkOffset}`;
        }
        if (this.mimetalkSearchQuery.trim()) {
          url += `&search_str=${encodeURIComponent(this.mimetalkSearchQuery.trim())}`;
        }
        if (this.mimetalkStatusFilter) {
          url += `&block_status=${this.mimetalkStatusFilter}`;
        }
        if (this.mimetalkHasLimit) {
          url += `&has_limit=${this.mimetalkHasLimit}`;
        }
        const res = await api.get(url);
        loader?.hide();
        if (Array.isArray(res.data)) {
          this.sipnumbers = res.data.map((item) => ({
            ...item,
            package_name: item.package_id?.name || "",
          }));
          this.mimetalkTotalCount = res.data.length;
        } else {
          this.sipnumbers = (res.data.results || []).map((item) => ({
            ...item,
            package_name: item.package_id?.name || "",
          }));
          this.mimetalkTotalCount = res.data.count || 0;
        }
      } catch (error) {
        loader?.hide();
        console.error("Service load failed", error);
        this.$bvToast.toast("Failed to load MiME Talk services", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      }
    },

    formatDateForApi(dateTimeStr) {
        if (!dateTimeStr) return '';
        
        try {
          const parts = dateTimeStr.split(' ');
          const dateParts = parts[0].split('/');
          const timeParts = parts[1] ? parts[1].split(':') : ['00', '00', '00'];
          
          const day = dateParts[0].padStart(2, '0');
          const month = dateParts[1].padStart(2, '0');
          const year = dateParts[2];
          const hour = timeParts[0].padStart(2, '0');
          const minute = timeParts[1].padStart(2, '0');
          const second = timeParts[2] ? timeParts[2].padStart(2, '0') : '00';
          
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        } catch (error) {
          console.error('Date parsing error:', error);
          return '';
        }
    },

    async searchCdr() {
        const loader = this.$showCustomLoader();
        try {
          const formatDateTimeForApi = (dateTimeStr) => {
            if (!dateTimeStr) return '';
            
            const parts = dateTimeStr.split(' ');
            const dateParts = parts[0].split('/');
            const timeParts = parts[1] ? parts[1].split(':') : ['00', '00', '00'];
            
            const day = dateParts[0].padStart(2, '0');
            const month = dateParts[1].padStart(2, '0');
            const year = dateParts[2];
            const hour = timeParts[0].padStart(2, '0');
            const minute = timeParts[1].padStart(2, '0');
            const second = timeParts[2] ? timeParts[2].padStart(2, '0') : '00';
            
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
          };
          
          const params = {
            sip_number: this.cdrFilter.sip_number,
            from_date: formatDateTimeForApi(this.cdrFilter.from_date),
            to_date: formatDateTimeForApi(this.cdrFilter.to_date),
          };
          
          const res = await api.get("/api/v1/iptsp/get_customer_cdrs_report/", { params });
          loader.hide();
          this.cdrResults = res.data?.cdrs || [];
          this.currentPage = 1;
          this.cdrFilter.search = ""; // Reset search when new data is loaded
        } catch (error) {
          loader.hide();
          console.error("CDR Error", error);
          this.$bvToast.toast("Failed to fetch CDR data", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
    },

    exportExcel() {
      if (!this.filteredCdrResults.length) {
        this.$bvToast.toast("No data to export", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }
      
      // Map only the required fields for export with serial number
      const exportData = this.filteredCdrResults.map((cdr, index) => ({
        'Sl No.': index + 1,
        'Caller': cdr.cli || '',
        'Callee': cdr.cld || '',
        'Connect Time': cdr.connect_time || '',
        'Disconnect Time': cdr.disconnect_time || '',
        'Duration': cdr.billed_duration || '',
        'Cost': cdr.cost || '',
        'Release Source': cdr.release_source || '',
        'Description': cdr.description || ''
      }));
      
      // Add statistics row
      exportData.push({
        'Sl No.': '',
        'Caller': 'STATISTICS',
        'Callee': '',
        'Connect Time': '',
        'Disconnect Time': '',
        'Duration': this.cdrStatistics.totalDuration,
        'Cost': this.cdrStatistics.totalCost,
        'Release Source': '',
        'Description': `Total Calls: ${this.cdrStatistics.totalCalls}`
      });
      
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CDR_Report");
      
      // Auto-size columns
      const wscols = [
        { wch: 8 },  // Sl No.
        { wch: 20 }, // Caller
        { wch: 20 }, // Callee
        { wch: 30 }, // Connect Time
        { wch: 30 }, // Disconnect Time
        { wch: 12 }, // Duration
        { wch: 12 }, // Cost
        { wch: 15 }, // Release Source
        { wch: 25 }, // Description
      ];
      worksheet['!cols'] = wscols;
      
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(data, `cdr_report_${new Date().toISOString().slice(0,19)}.xlsx`);
    },

    async checkBalance(item) {
      try {
        const userData = decrypt(localStorage.getItem("userData"));
        const username = userData?.username;
        const loader = this.$showCustomLoader();
        this.currentSipNumber = item.sip_number || '';
        const res = await api.get(
          `/api/v1/iptsp/get_balance_and_transaction/${username}/?sip_number=${item.sip_number}`
        );

        this.balance = Number(res.data.balance).toFixed(2) || 0;
        this.transactions = res.data.payment_list || [];

        this.$bvModal.show("balanceModal");
        loader.hide();
      } catch (error) {
        console.error("Balance check failed", error);
      }
    },

    openPasswordModal(item) {
      this.passwordForm.id = item.id;
      this.passwordForm.new_password = "";
      this.currentSipNumber = item.sip_number || '';

      this.$bvModal.show("passwordModal");
    },

    async changePassword() {
      try {
        await api.post("/mime-talk-change-password", {
          sip_id: this.selectedSip.sip_id,
          new_password: this.newPassword,
        });

        this.$bvModal.hide("passwordModal");
      } catch (error) {
        console.error("Password change failed", error);
      }
    },

    async submitPayment() {
      this.$refs.formBalanceRules.validate().then(async (success) => {
        if (!success) return;

        const transferAmount = Number(this.paymentData.transfer_balance_amount);
        if (!Number.isFinite(transferAmount) || transferAmount <= 0) {
          this.$bvToast.toast("Amount must be greater than 0", {
            title: "Validation Error",
            variant: "warning",
            solid: true,
          });
          return;
        }

        const loader = this.$showCustomLoader();
        try {
            const payload = {
              transfer_balance_amount: transferAmount,
              sip_number: this.paymentData.sip_number,
            };

            const res = await api.post(
              "/selfcare/api/v1/customer/balance/transfer/iptsp/",
              payload
            );

            if (res.data?.message?.result === "success") {
              this.$bvToast.toast(res.data.message.message, {
                title: "Success",
                variant: "success",
                solid: true,
              });

              this.$bvModal.hide("payModal");
            } else {
              this.$bvToast.toast(
                res.data?.message?.message || "Payment failed",
                {
                  title: "Error",
                  variant: "danger",
                  solid: true,
                }
              );
            }
          } catch (error) {
            console.error("Payment failed", error);

            this.$bvToast.toast(
              error.response?.data?.message?.message ||
                error.response?.data?.message ||
                error.message ||
                "Payment failed",
              {
                title: "Error",
                variant: "danger",
                solid: true,
              }
            );
          } finally {
            loader.hide();
          }
      });
    },

    async submitPassword() {
      this.$refs.formPasswordRules.validate().then(async (success) => {
        if (success) {
          const loader = this.$showCustomLoader();
          try {
            const payload = {
              id: this.passwordForm.id,
              new_password: this.passwordForm.new_password,
            };

            const res = await api.post("/api/v1/iptsp_password_change/", payload);

            this.$bvToast.toast("Password changed successfully", {
              title: "Success",
              variant: "success",
              solid: true,
            });

            this.$bvModal.hide("passwordModal");
          } catch (error) {
            console.error("Password change failed", error);

            this.$bvToast.toast("Password change failed", {
              title: "Error",
              variant: "danger",
              solid: true,
            });
          } finally {
            loader.hide();
          }
        }
      });
    },

    payNow(item) {
      this.paymentData.sip_number = item.sip_number;
      this.paymentData.transfer_balance_amount = "";
      this.currentSipNumber = item.sip_number || '';

      this.$bvModal.show("payModal");
    },

    setLimitMethod(item) {
      if (!item.id) {
        this.$bvToast.toast("IPTSP line not found for this MiME Talk service", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.setLimitData.id = item.id;
      this.setLimitData.limit = item.limit || 0;
      this.currentSipNumber = item.sip_number || '';
      this.$bvModal.show("mimetalkSetLimitModal");
    },

    openLimitSetHistory(item) {
      if (!item.id) {
        this.$bvToast.toast("IPTSP line not found for this MiME Talk service", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.limitSetHistoryLineId = item.id;
      this.currentSipNumber = item.sip_number || '';
      this.$bvModal.show("mimetalkLimitSetHistoryModal");
    },

    async submitSetLimit() {
      this.$refs.formSetLimitRules.validate().then(async (success) => {
        if (!success) return;

        const limit = Number(this.setLimitData.limit);
        if (!Number.isFinite(limit) || limit <= 0 || !Number.isInteger(limit)) {
          this.$bvToast.toast("Limit must be a positive integer greater than 0", {
            title: "Validation Error",
            variant: "warning",
            solid: true,
          });
          return;
        }

        const loader = this.$showCustomLoader();

        try {
          const payload = {
            limit,
            id: this.setLimitData.id,
          };

          const res = await api.post("/api/v1/mimetalk_line_set_limit/", payload);

          if (res?.status === 200) {
            this.$bvToast.toast(res.data?.message || "Limit updated successfully", {
              title: "Success",
              variant: "success",
              solid: true,
            });
            this.$bvModal.hide("mimetalkSetLimitModal");
            await this.fetchMimeTalkServices();
          } else {
            this.$bvToast.toast(res.data?.message || "Failed to set limit", {
              title: "Error",
              variant: "danger",
              solid: true,
            });
          }
        } catch (error) {
          console.error("Set limit failed", error);

          const apiMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Failed to set limit";

          this.$bvToast.toast(apiMessage, {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        } finally {
          loader.hide();
        }
      });
    },

    getSelectedMimeTalkData() {
      const effectiveById = this.bulkRechargeAmountsById;
      return this.selectedLinesData
        .filter((item) => this.selectedRows.includes(item.id))
        .map((item) => {
          const line = {
            id: item.id,
            limit: parseFloat(item.limit) || 0,
          };

          if (Object.prototype.hasOwnProperty.call(effectiveById, item.id)) {
            line.recharge_amount = Math.max(0, Number(effectiveById[item.id]) || 0);
            return line;
          }

          const amount = Number(this.bulkRechargeAmountMap[item.id]);
          if (Number.isFinite(amount) && amount > 0) {
            line.recharge_amount = amount;
          }
          return line;
        });
    },

    getSelectedLineIds() {
      return this.selectedLinesData
        .filter((item) => this.selectedRows.includes(item.id))
        .map((item) => item.id);
    },

    isDefaultLimitRecharge(item) {
      if (!item) return false;
      const line = this.sipnumbers.find(
        sip =>
          this.normalizeSipNumber(sip.sip_number) ===
          this.normalizeSipNumber(item.sip_number)
      );
      if (!line) return false;
      const amount = Number(this.bulkRechargeAmountMap[line.id]);
      return !(Number.isFinite(amount) && amount > 0);
    },

    effectiveRechargeAmount(item) {
      if (!item) return 0;
      const key = this.normalizeSipNumber(item.sip_number);
      if (this.hasManualAmountEdit(item)) {
        const edited = Number(this.bulkRechargeEditedAmounts[key]);
        return Number.isFinite(edited) && edited >= 0 ? edited : 0;
      }

      if (this.bulkRechargeAmountMode === "limit") {
        const limit = Number(item.limit);
        return Number.isFinite(limit) && limit > 0 ? limit : 0;
      }

      if (this.bulkRechargeAmountMode === "consumed") {
        const limit = Number(item.limit) || 0;
        const balance = Number(item.balance) || 0;
        return limit - balance > 0 ? limit - balance : 0;
      }

      const line = this.sipnumbers.find(
        sip => this.normalizeSipNumber(sip.sip_number) === key
      );
      if (line) {
        const custom = Number(this.bulkRechargeAmountMap[line.id]);
        if (Number.isFinite(custom) && custom > 0) {
          return custom;
        }
      }
      return Math.max(0, Number(item.limit || item.amount_to_recharge) || 0);
    },

    hasManualAmountEdit(item) {
      if (!item) return false;
      const key = this.normalizeSipNumber(item.sip_number);
      return (
        !!key &&
        Object.prototype.hasOwnProperty.call(this.bulkRechargeEditedAmounts, key)
      );
    },

    getBulkRechargeAmountMax(item) {
      const limit = Number(item?.limit);
      return Number.isFinite(limit) && limit >= 0 ? limit : undefined;
    },

    isBulkRechargeAmountOverLimit(item) {
      const max = this.getBulkRechargeAmountMax(item);
      if (max === undefined) return false;
      return Number(this.effectiveRechargeAmount(item)) > max;
    },

    setBulkRechargeEditedAmount(item, amount, inputEl) {
      const key = this.normalizeSipNumber(item.sip_number);
      if (!key) return;
      const max = this.getBulkRechargeAmountMax(item);
      let next = Number(amount);
      if (!Number.isFinite(next) || next < 0) next = 0;
      if (max !== undefined && next > max) next = max;
      this.$set(this.bulkRechargeEditedAmounts, key, next);
      if (inputEl && String(inputEl.value) !== String(next)) {
        inputEl.value = String(next);
      }
    },

    onBulkRechargeAmountNativeInput(item, event) {
      const el = event?.target;
      if (!el) return;
      this.setBulkRechargeEditedAmount(item, el.value, el);
    },

    onBulkRechargeAmountKeydown(item, event) {
      const el = event?.target;
      if (!el) return;
      const key = event.key;
      if (
        event.ctrlKey ||
        event.metaKey ||
        event.altKey ||
        key === "Backspace" ||
        key === "Delete" ||
        key === "Tab" ||
        key === "Enter" ||
        key === "Escape" ||
        key === "ArrowLeft" ||
        key === "ArrowRight" ||
        key === "ArrowUp" ||
        key === "ArrowDown" ||
        key === "Home" ||
        key === "End"
      ) {
        return;
      }
      if (key.length !== 1) return;
      if (!/[0-9.]/.test(key)) return;

      const start = el.selectionStart ?? el.value.length;
      const end = el.selectionEnd ?? el.value.length;
      const nextValue = `${el.value.slice(0, start)}${key}${el.value.slice(end)}`;
      const parsed = parseFloat(nextValue);
      const max = this.getBulkRechargeAmountMax(item);
      if (max !== undefined && Number.isFinite(parsed) && parsed > max) {
        event.preventDefault();
      }
    },

    onBulkRechargeAmountPaste(item, event) {
      const el = event?.target;
      if (!el) return;
      const pasted = (event.clipboardData || window.clipboardData)?.getData("text");
      if (pasted == null) return;

      const start = el.selectionStart ?? el.value.length;
      const end = el.selectionEnd ?? el.value.length;
      const nextValue = `${el.value.slice(0, start)}${pasted}${el.value.slice(end)}`;
      const parsed = parseFloat(nextValue);
      const max = this.getBulkRechargeAmountMax(item);
      if (max !== undefined && Number.isFinite(parsed) && parsed > max) {
        event.preventDefault();
        this.setBulkRechargeEditedAmount(item, max, el);
      }
    },

    onBulkRechargeModeChange() {
      this.bulkRechargeEditedAmounts = {};
      this.bulkRechargePreviewPage = 1;
    },

    validateBulkSelection() {
      if (!this.selectedRows.length) {
        this.$bvToast.toast("Please select at least one MiME Talk line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return false;
      }

      const selectedData = this.getSelectedMimeTalkData();
      if (!selectedData.length) {
        this.$bvToast.toast("No valid lines selected", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return false;
      }

      const zeroLimitLines = selectedData.filter((line) => line.limit <= 0);
      if (zeroLimitLines.length) {
        this.$bvToast.toast(
          `${zeroLimitLines.length} selected line(s) have no recharge limit configured`,
          {
            title: "Warning",
            variant: "warning",
            solid: true,
          }
        );
        return false;
      }

      return true;
    },

    openBulkRechargeModal() {
      if (!this.validateBulkSelection()) return;

      this.resetBulkRechargeProgress();
      this.bulkRechargePreview = [];
      this.bulkRechargeTotal = 0;
      this.bulkRechargePreviewPage = 1;
      this.bulkRechargePreviewTotalCount = 0;
      this.bulkRechargeAmountMode = "default";
      this.bulkRechargeEditedAmounts = {};
      this.$bvModal.show("mimetalkBulkRechargeModal");
      this.getBulkRechargePreview();
    },

    async getBulkRechargePreview() {
      const loader = this.$showCustomLoader();
      try {
        const payload = {
          customer_id: this.userData?.username,
          action_type: "pre_check",
          lines: this.getSelectedMimeTalkData(),
          limit: -1,
        };

        const response = await api.post("/api/v1/mimetalk_bulk_recharge/", payload);

        if (response.data && response.data.preview) {
          this.bulkRechargePreview = response.data.preview;
          this.bulkRechargeTotal = response.data.total_recharge || 0;
          this.bulkRechargePreviewTotalCount = response.data.preview.length;
        }
      } catch (error) {
        console.error("Bulk recharge preview failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to load preview",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
        this.$bvModal.hide("mimetalkBulkRechargeModal");
      } finally {
        loader.hide();
      }
    },

    async submitBulkRecharge() {
      if (this.hasBulkRechargeAmountOverLimit) {
        this.$bvToast.toast(
          "Amount to recharge cannot exceed the limit for any line",
          {
            title: "Warning",
            variant: "warning",
            solid: true,
          }
        );
        return;
      }

      this.bulkRechargeSubmitting = true;
      const loader = this.$showCustomLoader();

      try {
        const payload = {
          customer_id: this.userData?.username,
          action_type: "submit_recharge",
          lines: this.getSelectedMimeTalkData(),
        };

        const response = await api.post("/api/v1/mimetalk_bulk_recharge/", payload);
        const jobId = response.data?.id;

        if (!jobId) {
          throw new Error("No recharge job id returned");
        }

        this.bulkRechargeJobId = jobId;
        this.bulkRechargeProgressing = true;
        this.bulkRechargeProgress = 0;
        this.bulkRechargeCompletedCount = 0;
        this.bulkRechargeTotalCount = this.bulkRechargePreview.length || 0;
        this.startBulkRechargePolling(jobId);
      } catch (error) {
        console.error("Bulk recharge failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || error.message || "Bulk recharge failed",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.bulkRechargeSubmitting = false;
        loader.hide();
      }
    },

    startBulkRechargePolling(jobId) {
      this.clearBulkRechargePollTimer();
      this.pollBulkRechargeStatus(jobId);
      this.bulkRechargePollTimer = setInterval(() => {
        this.pollBulkRechargeStatus(jobId);
      }, 2000);
    },

    async pollBulkRechargeStatus(jobId) {
      try {
        const response = await api.get(`/api/v1/mimetalk_bulk_recharge/${jobId}/`);
        const data = response.data || {};

        this.bulkRechargeProgress = Math.min(
          100,
          Number(data.completion_percentage) || 0
        );
        this.bulkRechargeCompletedCount = data.completed_count || 0;
        this.bulkRechargeTotalCount = data.total_count || this.bulkRechargeTotalCount;

        if (data.status === "completed" || this.bulkRechargeProgress >= 100) {
          this.bulkRechargeProgress = 100;
          this.clearBulkRechargePollTimer();

          this.$bvToast.toast("Bulk recharge completed successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });

          this.selectedRows = [];
          this.selectedLinesData = [];
          this.bulkRechargeProgressing = false;
          this.closeBulkRechargeModal();
          await this.fetchMimeTalkServices();
        }
      } catch (error) {
        console.error("Bulk recharge status poll failed:", error);
        this.clearBulkRechargePollTimer();
        this.bulkRechargeProgressing = false;
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to get recharge progress",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      }
    },

    clearBulkRechargePollTimer() {
      if (this.bulkRechargePollTimer) {
        clearInterval(this.bulkRechargePollTimer);
        this.bulkRechargePollTimer = null;
      }
    },

    resetBulkRechargeProgress() {
      this.clearBulkRechargePollTimer();
      this.bulkRechargeProgressing = false;
      this.bulkRechargeProgress = 0;
      this.bulkRechargeJobId = null;
      this.bulkRechargeCompletedCount = 0;
      this.bulkRechargeTotalCount = 0;
      this.bulkRechargeSubmitting = false;
    },

    closeBulkRechargeModal() {
      if (this.bulkRechargeProgressing) {
        return;
      }
      this.resetBulkRechargeProgress();
      this.$bvModal.hide("mimetalkBulkRechargeModal");
      this.bulkRechargePreview = [];
      this.bulkRechargeTotal = 0;
      this.bulkRechargeAmountMap = {};
      this.bulkRechargeAmountMode = "default";
      this.bulkRechargeEditedAmounts = {};
    },

    onBulkRechargePreviewLimitChange() {
      this.bulkRechargePreviewPage = 1;
    },

    openBulkSelectionModal() {
      this.resetBulkSelectionModal();
      this.$bvModal.show("mimetalkBulkSelectionModal");
    },

    closeBulkSelectionModal() {
      this.$bvModal.hide("mimetalkBulkSelectionModal");
      this.resetBulkSelectionModal();
    },

    resetBulkSelectionModal() {
      this.bulkSelectionFile = null;
      this.bulkSelectionMatched = [];
      this.bulkSelectionUnmatched = [];
      this.bulkSelectionBlocked = [];
      this.bulkSelectionInvalidAmounts = [];
    },

    normalizeSipNumber(sipNumber) {
      return String(sipNumber || "")
        .trim()
        .replace(/[\s-]/g, "")
        .replace(/\D/g, "");
    },

    onBulkSelectionFileSelected(file) {
      this.bulkSelectionMatched = [];
      this.bulkSelectionUnmatched = [];
      this.bulkSelectionBlocked = [];
      this.bulkSelectionInvalidAmounts = [];
      if (!file) {
        this.bulkSelectionFile = null;
      }
    },

    async uploadBulkSelection() {
      if (!this.bulkSelectionFile) return;
      const loader = this.$showCustomLoader();
      try {
        const username = this.userData?.username;
        const res = await api.get(`/api/v1/iptsp/sipnumber/${username}/?search_for=all&limit=-1`);
        let allSipnumbers = [];
        if (Array.isArray(res.data)) {
          allSipnumbers = res.data.map((item) => ({
            ...item,
            package_name: item.package_id?.name || "",
          }));
        } else {
          allSipnumbers = (res.data.results || []).map((item) => ({
            ...item,
            package_name: item.package_id?.name || "",
          }));
        }
        this.sipnumbers = allSipnumbers;
        this.mimetalkTotalCount = allSipnumbers.length;
        this.mimetalkLimit = -1;
        this.mimetalkPage = 1;
      } catch (error) {
        loader.hide();
        console.error("Failed to fetch all SIP numbers", error);
        this.$bvToast.toast("Failed to fetch SIP numbers", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }
      loader.hide();
      await this.processBulkSelectionFile(this.bulkSelectionFile);
    },

    readExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          resolve(jsonData);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },

    isValidBulkRechargeAmount(value, limit) {
      if (value === undefined || value === null || value === "") {
        return true;
      }
      const amount = Number(value);
      if (!Number.isFinite(amount) || !Number.isInteger(amount)) {
        return false;
      }
      if (amount < 0) {
        return false;
      }
      if (amount > 0 && Number.isFinite(Number(limit)) && amount > Number(limit)) {
        return false;
      }
      return true;
    },

    hasExcelRechargeAmount(value) {
      if (value === undefined || value === null || value === "") {
        return false;
      }
      const amount = Number(value);
      return Number.isFinite(amount) && amount > 0;
    },

    async processBulkSelectionFile(file) {
      if (!file) {
        this.bulkSelectionMatched = [];
        this.bulkSelectionUnmatched = [];
        this.bulkSelectionBlocked = [];
        this.bulkSelectionInvalidAmounts = [];
        return;
      }

      const loader = this.$showCustomLoader();
      try {
        this.bulkSelectionUnmatched = [];
        this.bulkSelectionBlocked = [];
        this.bulkSelectionInvalidAmounts = [];
        const excelData = await this.readExcelFile(file);

        const excelRowMap = new Map();
        excelData.forEach((row) => {
          const mimeTalkNumber = String(row.mime_talk_number ?? "").trim();
          if (!mimeTalkNumber) return;
          const normalized = this.normalizeSipNumber(mimeTalkNumber);
          if (normalized) {
            excelRowMap.set(normalized, {
              mime_talk_number: mimeTalkNumber,
              recharge_amount: row.recharge_amount,
            });
          }
        });

        const excelMimeTalkNumbers = [...excelRowMap.values()].map((row) => row.mime_talk_number);

        if (!excelMimeTalkNumbers.length) {
          this.bulkSelectionMatched = [];
          this.bulkSelectionUnmatched = [];
          this.bulkSelectionInvalidAmounts = [];
          this.$bvToast.toast(
            "Invalid Excel data. Please ensure columns: mime_talk_number, recharge_amount (optional)",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return;
        }

        const normalizedExcelSet = new Set(
          excelMimeTalkNumbers.map((num) => this.normalizeSipNumber(num)).filter(Boolean)
        );
        const matched = [];
        const matchedNormalized = new Set();
        const invalidAmounts = [];
        const invalidNormalized = new Set();
        const blockedNormalized = new Set();
        const mobileMatchedNormalized = new Set();

        const processMatch = (item, excelRow, normalizedKey) => {
          if (item.block_status === 'blocked') {
            blockedNormalized.add(normalizedKey);
            return;
          }
          if (!this.isValidBulkRechargeAmount(excelRow.recharge_amount, item.limit)) {
            invalidAmounts.push({
              sip_number: item.sip_number,
              recharge_amount: excelRow.recharge_amount,
            });
            invalidNormalized.add(normalizedKey);
            return;
            }
          matched.push({
            ...item,
            recharge_amount: this.hasExcelRechargeAmount(excelRow.recharge_amount)
              ? excelRow.recharge_amount
              : null,
          });
          matchedNormalized.add(normalizedKey);
        };

        this.sipnumbers.forEach((item) => {
          const normalizedSipNumber = this.normalizeSipNumber(item.sip_number);
          const excelRow = excelRowMap.get(normalizedSipNumber);
          if (
            normalizedSipNumber &&
            normalizedExcelSet.has(normalizedSipNumber) &&
            !matchedNormalized.has(normalizedSipNumber)
          ) {
            processMatch(item, excelRow, normalizedSipNumber);
          }
        });

        this.sipnumbers.forEach((item) => {
          if (!item.mobile_number) return;
          const normalizedMobile = this.normalizeSipNumber(item.mobile_number);
          if (
            normalizedMobile &&
            normalizedExcelSet.has(normalizedMobile) &&
            !matchedNormalized.has(normalizedMobile) &&
            !invalidNormalized.has(normalizedMobile) &&
            !blockedNormalized.has(normalizedMobile) &&
            !mobileMatchedNormalized.has(normalizedMobile)
          ) {
            const excelRow = excelRowMap.get(normalizedMobile);
            processMatch(item, excelRow, normalizedMobile);
            mobileMatchedNormalized.add(normalizedMobile);
          }
        });

        this.bulkSelectionMatched = matched;
        this.bulkSelectionInvalidAmounts = invalidAmounts;
        this.bulkSelectionBlocked = [...excelRowMap.values()]
          .map((row) => row.mime_talk_number)
          .filter((num) => blockedNormalized.has(this.normalizeSipNumber(num)));
        this.bulkSelectionUnmatched = excelMimeTalkNumbers.filter((num) => {
          const normalized = this.normalizeSipNumber(num);
          return normalized && !matchedNormalized.has(normalized) && !invalidNormalized.has(normalized) && !blockedNormalized.has(normalized);
        });

        if (invalidAmounts.length) {
          this.$bvToast.toast(
            "Each recharge amount must be a positive value and not exceeding the respective line limit amount",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return;
        }

        const unmatchedCount = this.bulkSelectionUnmatched.length;
        const blockedCount = this.bulkSelectionBlocked.length;
        if (!matched.length) {
          this.$bvToast.toast("No SIP numbers matched with your MiME Talk lines", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
        } else {
          let msg = `${matched.length} matched`;
          if (unmatchedCount > 0) msg += `, ${unmatchedCount} not found`;
          if (blockedCount > 0) msg += `, ${blockedCount} skipped (inactive)`;
          this.$bvToast.toast(msg, {
            title: "Info",
            variant: "info",
            solid: true,
          });
        }
      } catch (error) {
        console.error("Bulk selection match failed:", error);
        this.bulkSelectionMatched = [];
        this.bulkSelectionUnmatched = [];
        this.bulkSelectionBlocked = [];
        this.bulkSelectionInvalidAmounts = [];
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to process Excel file",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        loader.hide();
      }
    },

    removeBulkSelectionRow(id) {
      this.bulkSelectionMatched = this.bulkSelectionMatched.filter(
        (item) => item.id !== id
      );
    },

    submitBulkSelectionRecharge() {
      if (!this.bulkSelectionMatched.length) {
        this.$bvToast.toast("Please match at least one MiME Talk line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      const amountMap = {};
      this.bulkSelectionMatched.forEach((item) => {
        if (this.hasExcelRechargeAmount(item.recharge_amount)) {
          amountMap[item.id] = Number(item.recharge_amount);
          return;
        }
        // Empty Excel amount → send line limit in the background
        const limit = Number(item.limit);
        if (Number.isFinite(limit) && limit > 0) {
          amountMap[item.id] = limit;
        }
      });
      this.bulkRechargeAmountMap = amountMap;

      this.selectedRows = this.bulkSelectionMatched.map((item) => item.id);
      this.selectedLinesData = this.bulkSelectionMatched.map((item) => ({
        id: item.id,
        limit: parseFloat(item.limit) || 0,
      }));
      this.closeBulkSelectionModal();
      this.$nextTick(() => {
        this.openBulkRechargeModal();
      });
    },

    openBulkSetLimitSelectionModal() {
      this.resetBulkSetLimitSelectionModal();
      this.$bvModal.show("mimetalkBulkSetLimitSelectionModal");
    },

    closeBulkSetLimitSelectionModal() {
      this.$bvModal.hide("mimetalkBulkSetLimitSelectionModal");
      this.resetBulkSetLimitSelectionModal();
    },

    resetBulkSetLimitSelectionModal() {
      this.bulkSetLimitSelectionFile = null;
      this.bulkSetLimitSelectionMatched = [];
      this.bulkSetLimitSelectionUnmatched = [];
      this.bulkSetLimitSelectionInvalid = [];
    },

    onBulkSetLimitSelectionFileSelected(file) {
      this.bulkSetLimitSelectionMatched = [];
      this.bulkSetLimitSelectionUnmatched = [];
      this.bulkSetLimitSelectionInvalid = [];
      if (!file) {
        this.bulkSetLimitSelectionFile = null;
      }
    },

    async uploadBulkSetLimitSelection() {
      if (!this.bulkSetLimitSelectionFile) return;
      await this.processBulkSetLimitSelectionFile(this.bulkSetLimitSelectionFile);
    },

    isValidBulkSetLimitValue(limit) {
      const value = Number(limit);
      return Number.isFinite(value) && value > 0 && Number.isInteger(value);
    },

    async processBulkSetLimitSelectionFile(file) {
      if (!file) {
        this.bulkSetLimitSelectionMatched = [];
        this.bulkSetLimitSelectionUnmatched = [];
        this.bulkSetLimitSelectionInvalid = [];
        return;
      }

      const loader = this.$showCustomLoader();
      try {
        this.bulkSetLimitSelectionUnmatched = [];
        this.bulkSetLimitSelectionInvalid = [];
        const excelData = await this.readExcelFile(file);

        const excelRows = excelData
          .map((row) => ({
            sip_number: String(row.sip_number ?? "").trim(),
            limit: row.limit,
          }))
          .filter((row) => row.sip_number);

        if (!excelRows.length) {
          this.bulkSetLimitSelectionMatched = [];
          this.bulkSetLimitSelectionUnmatched = [];
          this.$bvToast.toast(
            "Invalid Excel data. Please ensure columns: sip_number, limit",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return;
        }

        const invalidRows = excelRows.filter(
          (row) => !this.isValidBulkSetLimitValue(row.limit)
        );
        if (invalidRows.length) {
          this.bulkSetLimitSelectionMatched = [];
          this.bulkSetLimitSelectionInvalid = invalidRows;
          this.$bvToast.toast(
            "Each limit must be a positive integer greater than 0",
            {
              title: "Error",
              variant: "danger",
              solid: true,
            }
          );
          return;
        }

        const excelRowMap = new Map();
        excelRows.forEach((row) => {
          const normalized = this.normalizeSipNumber(row.sip_number);
          if (normalized) {
            excelRowMap.set(normalized, row);
          }
        });

        const matched = [];
        const matchedNormalized = new Set();
        const mobileMatchedNormalized = new Set();

        this.sipnumbers.forEach((item) => {
          const normalizedSipNumber = this.normalizeSipNumber(item.sip_number);
          const excelRow = excelRowMap.get(normalizedSipNumber);
          if (
            normalizedSipNumber &&
            excelRow &&
            !matchedNormalized.has(normalizedSipNumber)
          ) {
            matched.push({
              id: item.id,
              mobile_number: item.mobile_number,
              sip_number: item.sip_number,
              limit: Number(excelRow.limit),
            });
            matchedNormalized.add(normalizedSipNumber);
          }
        });

        this.sipnumbers.forEach((item) => {
          if (!item.mobile_number) return;
          const normalizedMobile = this.normalizeSipNumber(item.mobile_number);
          const excelRow = excelRowMap.get(normalizedMobile);
          if (
            normalizedMobile &&
            excelRow &&
            !matchedNormalized.has(normalizedMobile) &&
            !mobileMatchedNormalized.has(normalizedMobile)
          ) {
            matched.push({
              id: item.id,
              mobile_number: item.mobile_number,
              sip_number: item.sip_number,
              limit: Number(excelRow.limit),
            });
            matchedNormalized.add(normalizedMobile);
            mobileMatchedNormalized.add(normalizedMobile);
          }
        });

        this.bulkSetLimitSelectionMatched = matched;
        this.bulkSetLimitSelectionUnmatched = [...excelRowMap.values()]
          .map((row) => row.sip_number)
          .filter((num) => {
            const normalized = this.normalizeSipNumber(num);
            return normalized && !matchedNormalized.has(normalized);
          });

        const unmatchedCount = this.bulkSetLimitSelectionUnmatched.length;
        if (!matched.length) {
          this.$bvToast.toast("No SIP numbers matched with your MiME Talk lines", {
            title: "Warning",
            variant: "warning",
            solid: true,
          });
        } else if (unmatchedCount > 0) {
          this.$bvToast.toast(
            `${matched.length} matched, ${unmatchedCount} not found`,
            {
              title: "Info",
              variant: "info",
              solid: true,
            }
          );
        } else {
          this.$bvToast.toast(`${matched.length} SIP number(s) matched`, {
            title: "Success",
            variant: "success",
            solid: true,
          });
        }
      } catch (error) {
        console.error("Bulk set limit selection match failed:", error);
        this.bulkSetLimitSelectionMatched = [];
        this.bulkSetLimitSelectionUnmatched = [];
        this.bulkSetLimitSelectionInvalid = [];
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to process Excel file",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        loader.hide();
      }
    },

    getBulkSetLimitLinesData() {
      return this.bulkSetLimitPendingLines.map((item) => ({
        id: item.id,
        limit: Number(item.limit),
      }));
    },

    submitBulkSetLimitSelection() {
      if (!this.bulkSetLimitSelectionMatched.length) {
        this.$bvToast.toast("Please match at least one MiME Talk line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.bulkSetLimitPendingLines = this.bulkSetLimitSelectionMatched.map((item) => ({
        id: item.id,
        limit: Number(item.limit),
        mobile_number: item.mobile_number,
        sip_number: item.sip_number,
      }));
      this.closeBulkSetLimitSelectionModal();
      this.$nextTick(() => {
        this.openBulkSetLimitModal();
      });
    },

    openBulkSetLimitModal() {
      if (!this.bulkSetLimitPendingLines.length) {
        this.$bvToast.toast("Please upload and match at least one MiME Talk line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.bulkSetLimitPreview = [];
      this.$bvModal.show("mimetalkBulkSetLimitModal");
      this.getBulkSetLimitPreview();
    },

    async getBulkSetLimitPreview() {
      const loader = this.$showCustomLoader();
      try {
        const payload = {
          customer_id: this.userData?.username,
          action_type: "pre_check",
          lines: this.getBulkSetLimitLinesData(),
        };

        const response = await api.post("/api/v1/mimetalk_bulk_set_limit/", payload);

        if (response.data && response.data.preview) {
          this.bulkSetLimitPreview = response.data.preview;
        }
      } catch (error) {
        console.error("Bulk set limit preview failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to load preview",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
        this.$bvModal.hide("mimetalkBulkSetLimitModal");
      } finally {
        loader.hide();
      }
    },

    async submitBulkSetLimit() {
      this.bulkSetLimitSubmitting = true;
      const loader = this.$showCustomLoader();

      try {
        const payload = {
          customer_id: this.userData?.username,
          action_type: "submit_recharge",
          lines: this.getBulkSetLimitLinesData(),
        };

        const response = await api.post("/api/v1/mimetalk_bulk_set_limit/", payload);

        if (response?.status === 200) {
          this.$bvToast.toast(
            response.data?.message || "Bulk set limit successful",
            {
              title: "Success",
              variant: "success",
              solid: true,
            }
          );

          this.resetBulkSetLimitState();
          await this.fetchMimeTalkServices();
          return;
        }

        this.$bvToast.toast(response.data?.message || "Bulk set limit failed", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } catch (error) {
        console.error("Bulk set limit failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || error.message || "Bulk set limit failed",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.bulkSetLimitSubmitting = false;
        loader.hide();
      }
    },

    resetBulkSetLimitState() {
      this.$bvModal.hide("mimetalkBulkSetLimitModal");
      this.bulkSetLimitPreview = [];
      this.bulkSetLimitPendingLines = [];
      this.resetBulkSetLimitSelectionModal();
    },

    closeBulkSetLimitModal() {
      if (this.bulkSetLimitSubmitting) {
        return;
      }
      this.$bvModal.hide("mimetalkBulkSetLimitModal");
      this.bulkSetLimitPreview = [];
      this.bulkSetLimitPendingLines = [];
    },

    openDownloadSummaryModal() {
      if (!this.selectedRows.length) {
        this.$bvToast.toast("Please select at least one MiME Talk line", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.summaryFilters.from_date = moment().startOf("month").format("YYYY-MM-DD");
      this.summaryFilters.to_date = moment().format("YYYY-MM-DD");
      this.summaryDateConfig.toDate.minDate = this.summaryFilters.from_date;
      this.$bvModal.show("mimetalkDownloadSummaryModal");
    },

    async downloadSummary() {
      const isValid = await this.$refs.summaryRules.validate();
      if (!isValid) return;

      this.downloading = true;
      const loader = this.$showCustomLoader();

      try {
        const payload = {
          customer_id: this.userData?.username,
          from_date: `${this.summaryFilters.from_date} 00:00:00`,
          to_date: `${this.summaryFilters.to_date} 23:59:59`,
          line_ids: this.getSelectedLineIds(),
        };

        const response = await api.post("/api/v1/mimetalk_lines_summary/", payload);

        if (response.data && response.data.summary) {
          this.exportSummaryToExcel(response.data.summary);
          this.$bvToast.toast("Summary downloaded successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$bvModal.hide("mimetalkDownloadSummaryModal");
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Download summary failed:", error);
        this.$bvToast.toast(
          error.response?.data?.message || "Failed to download summary",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        this.downloading = false;
        loader.hide();
      }
    },

    exportSummaryToExcel(data) {
      const excelData = data.map((item) => ({
        Number: item.mobile_number,
        "Total Calls": item.total_count || 0,
        "Total Duration": (item.duration_sum || 0).toFixed(2),
        "Total Cost": (item.cost_sum || 0).toFixed(4),
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet["!cols"] = [
        { wch: 15 },
        { wch: 12 },
        { wch: 20 },
        { wch: 15 },
      ];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "MiME Talk Summary");

      const fileName = `mimetalk_summary_${this.summaryFilters.from_date}_to_${this.summaryFilters.to_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },

    openResendModal(item) {
      this.selectedItem = item.sip_number;
      this.currentSipNumber = item.sip_number || '';
      this.$bvModal.show("resend-modal");
    },

    // Confirm resend action
    async confirmResend() {
      const loader = this.$showCustomLoader();
      try {
        const userData = decrypt(localStorage.getItem("userData"));
        const username = userData?.username;
        const res = await api.get(`/api/v1/iptsp/sipnumber/${username}/`);
        const sipData = res.data[0];

        const payload = {
          mobile_number: sipData.mobile_number,
          sip_number: sipData.sip_number,
          sip_password: sipData.sip_password,
        };

        await api.post("/api/v1/iptsp_password_resend/", payload);

        this.$bvToast.toast("Password resent successfully", {
          title: "Success",
          variant: "success",
          solid: true,
        });

        this.$bvModal.hide("resend-modal");
      } catch (error) {
        console.error("Resend password failed", error);

        this.$bvToast.toast("Failed to resend password", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        loader.hide();
      }
    },
    resetCdrModal() {
      // Reset search and pagination when modal is closed
      this.cdrFilter.search = "";
      this.cdrResults = [];
      this.cdrFilter.sip_number = "";
      this.cdrFilter.from_date = "";
      this.cdrFilter.to_date = "";
      this.currentPage = 1;
    },

  },

  mounted() {
    this.fetchMimeTalkServices();
  },

  beforeDestroy() {
    this.clearBulkRechargePollTimer();
    clearTimeout(this.mimetalkSearchTimer);
  },
};
</script>
<style scoped>
.table-responsive {
  height: 400px;
  overflow-y: auto;
}

.responsive-video {
  width: 100%;
  height: auto;
  max-width: 100%;
}

:deep(.bulk-modal-content) {
  border: 0.5px solid #e0ddd5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
}

.bulk-modal-wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.bm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #e8e5dc;
}

.bm-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bm-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #E6F1FB;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.bm-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a18;
}

.bm-subtitle {
  margin: 0;
  font-size: 12px;
  color: #888780;
}

.bm-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 18px;
  line-height: 1;
  color: #888780;
  border-radius: 6px;
  transition: background 0.15s;
}
.bm-close-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.bm-close-btn:hover:not(:disabled) {
  background: #f1efe8;
  color: #444441;
}

.bm-body {
  padding: 1.25rem 1.5rem;
}

.bm-table-wrapper {
  border: 0.5px solid #e8e5dc;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1.25rem;
}

.bm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.bm-table thead tr {
  background: #f7f5f0;
}

.bm-table thead th {
  padding: 10px 14px;
  font-weight: 500;
  color: #888780;
  border-bottom: 0.5px solid #e8e5dc;
}

.bm-table tbody tr {
  border-bottom: 0.5px solid #f1efe8;
  transition: background 0.1s;
}

.bm-table tbody tr:last-child {
  border-bottom: none;
}

.bm-table tbody tr:hover {
  background: #fafaf8;
}

.bm-table tbody td {
  padding: 10px 14px;
}

.bm-table tfoot tr {
  background: #f7f5f0;
  border-top: 0.5px solid #e0ddd5;
}

.bm-table tfoot td {
  padding: 10px 14px;
}

.bm-mono {
  font-family: 'SFMono-Regular', 'Consolas', 'Liberation Mono', monospace;
  font-size: 12px;
  color: #1a1a18;
}

.bm-muted {
  color: #888780;
}

.bm-amount {
  font-weight: 500;
  color: #0F6E56;
}

.bm-amount-input {
  max-width: 130px;
  margin-left: auto;
  text-align: right;
  font-weight: 500;
}

.bm-amount-error {
  font-size: 11px;
  font-weight: 400;
  color: #b42318;
  margin-top: 2px;
}

.bm-default-limit {
  font-size: 12px;
  font-weight: 400;
}

.bm-total-label {
  font-weight: 500;
  color: #1a1a18;
}

.bm-total-value {
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  color: #1a1a18;
}

.text-left  { text-align: left; }
.text-right { text-align: right; }

.bm-warning {
  background: #FAEEDA;
  border: 0.5px solid #FAC775;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.bm-warning-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.bm-warning-text {
  margin: 0;
  font-size: 13px;
  color: #92640A;
  line-height: 1.5;
}

.bm-loading {
  text-align: center;
  padding: 2.5rem 0;
}

.bm-loading-text {
  margin-top: 0.75rem;
  font-size: 13px;
  color: #888780;
}

.bm-progress {
  padding: 2rem 0.5rem 1rem;
  text-align: center;
}

.bm-progress-label {
  margin: 0 0 1rem;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.bm-progress-bar {
  max-width: 420px;
  margin: 0 auto;
}

.bm-progress-hint {
  margin: 1rem 0 0;
  font-size: 13px;
  color: #888780;
}

.bm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 1rem 1.5rem;
  border-top: 0.5px solid #e8e5dc;
  background: #f7f5f0;
}

.bm-btn {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.15s, background 0.15s;
}

.bm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bm-btn-cancel {
  background: #ffffff;
  border: 0.5px solid #d3d1c7;
  color: #888780;
}

.bm-btn-cancel:hover:not(:disabled) {
  background: #f1efe8;
  color: #444441;
}

.bm-btn-confirm {
  background: #185FA5;
  border: none;
  color: #ffffff;
}

.bm-btn-confirm:hover:not(:disabled) {
  background: #0c447c;
}

:deep(.ds-modal-content) {
  border: 0.5px solid #e0ddd5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
}

.ds-wrapper {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.ds-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.5rem;
  border-bottom: 0.5px solid #e8e5dc;
}

.ds-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ds-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #E1F5EE;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ds-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a18;
}

.ds-subtitle {
  margin: 0;
  font-size: 12px;
  color: #888780;
}

.ds-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 18px;
  line-height: 1;
  color: #888780;
  border-radius: 6px;
  transition: background 0.15s;
}
.ds-close-btn:hover {
  background: #f1efe8;
  color: #444441;
}

.ds-body {
  padding: 1.25rem 1.5rem;
}

.ds-date-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 1rem;
}

.ds-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ds-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  color: #5F5E5A;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.ds-input-wrap {
  border: 0.5px solid #d3d1c7;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}

.ds-input-wrap:focus-within {
  border-color: #185FA5;
}

.ds-input-wrap.ds-input-error {
  border-color: #E24B4A;
  background: #fff8f8;
}

.ds-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 9px 12px;
  font-size: 13px;
  color: #1a1a18;
  background: transparent;
  font-family: inherit;
}

.ds-input-wrap ::v-deep .ds-summary-date.form-control,
.ds-input-wrap ::v-deep .flatpickr-input.ds-summary-date {
  width: 100%;
  border: none;
  outline: none;
  padding: 9px 12px;
  font-size: 13px;
  color: #1a1a18;
  background: transparent;
  font-family: inherit;
  box-shadow: none;
  height: auto;
  min-height: 0;
}

.ds-error {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #A32D2D;
  margin-top: 2px;
}

.ds-lines-badge {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #E6F1FB;
  border: 0.5px solid #B5D4F4;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 1rem;
}

.ds-lines-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ds-lines-label {
  font-size: 13px;
  color: #185FA5;
  font-weight: 500;
}

.ds-lines-count {
  font-size: 12px;
  font-weight: 500;
  background: #185FA5;
  color: #ffffff;
  padding: 2px 10px;
  border-radius: 20px;
}

.ds-info {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #f7f5f0;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 1.25rem;
}

.ds-info-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.ds-info-text {
  margin: 0;
  font-size: 12px;
  color: #5F5E5A;
  line-height: 1.6;
}

.ds-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 0.25rem;
}

.ds-btn {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.15s, background 0.15s;
}

.ds-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ds-btn-cancel {
  background: #ffffff;
  border: 0.5px solid #d3d1c7;
  color: #888780;
}

.ds-btn-cancel:hover:not(:disabled) {
  background: #f1efe8;
  color: #444441;
}

.ds-btn-download {
  background: #0F6E56;
  border: none;
  color: #ffffff;
}

.ds-btn-download:hover:not(:disabled) {
  background: #085041;
}

::v-deep .bulk-selection-modal-header {
  align-items: center;
  padding: 1rem 1.25rem;
}

::v-deep .bulk-selection-modal-header .close {
  margin: 0;
  padding: 0.25rem 0.5rem;
  flex-shrink: 0;
}

.kothon-bulk-actions {
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.5rem;
}

.kothon-bulk-action-btn {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
  white-space: nowrap;
  font-weight: 600;
  letter-spacing: 0.01em;
  box-shadow: 0 1px 2px rgba(22, 29, 37, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.kothon-bulk-action-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(22, 29, 37, 0.16);
}

@media (max-width: 575.98px) {
  .kothon-bulk-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .kothon-bulk-action-btn {
    width: 100%;
    white-space: normal;
    justify-content: center;
  }
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .kothon-bulk-action-btn {
    flex: 1 1 calc(50% - 0.2rem);
    min-width: 0;
    white-space: normal;
  }
}

.bulk-selection-modal-header-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.bulk-selection-modal-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
}

.bulk-selection-upload-row {
  flex-wrap: wrap;
  gap: 0.5rem;
}

.bulk-selection-upload-row .form-group {
  flex: 1 1 12rem;
  min-width: 0;
  margin-right: 0 !important;
}

.bulk-selection-upload-row > .btn {
  flex: 0 0 auto;
  margin-top: 0 !important;
}

::v-deep .bulk-selection-matched-table {
  table-layout: fixed;
  width: 100%;
}

::v-deep .bulk-selection-matched-table th,
::v-deep .bulk-selection-matched-table td {
  vertical-align: middle;
}

.bulk-selection-unmatched {
  border-radius: 8px;
  padding: 0.75rem 1rem;
}

.bulk-selection-unmatched-title {
  font-size: 13px;
  font-weight: 600;
  color: #856404;
}

.bulk-selection-unmatched-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.bulk-selection-unmatched-chip {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  font-size: 12px;
  font-family: monospace;
  background: #fff8e6;
  border: 1px solid #f0d78c;
  border-radius: 4px;
  color: #664d03;
}

@media (max-width: 575.98px) {
  .bulk-selection-modal-header-inner {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-selection-modal-header-actions {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }

  .bulk-selection-modal-header-actions .btn {
    flex: 1 1 auto;
    min-width: 0;
  }

  .bulk-selection-upload-row {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-selection-upload-row > .btn {
    width: 100%;
  }
}

.bulk-selection-footer-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

.did-search-input {
  max-width: 300px;
  border-radius: 8px;
  font-size: 13px;
  padding: 0.35rem 0.75rem;
}

.mimetalk-search-input {
  width: 250px;
  border-radius: 8px;
  font-size: 13px;
  padding: 0.35rem 0.75rem;
}

.did-limit-select {
  width: auto;
  min-width: 80px;
  border-radius: 8px;
  font-size: 13px;
  padding: 0.35rem 0.5rem;
}

.mimetalk-status-select {
  width: auto;
  min-width: 170px;
  border-radius: 8px;
  font-size: 13px;
  padding: 0.35rem 0.5rem;
}

@media (max-width: 575.98px) {
  .did-search-input {
    max-width: 100%;
  }
  .mimetalk-search-input {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .bulk-selection-footer-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-selection-footer-actions .btn {
    width: 100%;
  }
}
</style>
